/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";
import PropTypes from "prop-types";
import qs from "qs";
import { useCountry, useModel } from "../../../../hooks";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import Button from "wonderbly-components/lib/Button";
import SelectField from "wonderbly-components/lib/SelectField";
import AvatarCreationModal from "../../../AvatarCreationModal";
import { track } from "src/client/js/analytics/facade";
import { getLocales } from ".././helpers";

const ProductHeroIIButtonAvatars = (props) => {
  const country = useCountry();
  const {
    prismicProduct,
    topology,
    prismicGlobalContentModel,
    productAvatarCreation,
    eagleProduct,
  } = useModel();
  const [avatarCreationVisible, setAvatarCreationVisible] = useState(false);
  const { locales, localeLabel } = getLocales(
    props.avatarCreation,
    eagleProduct.variants
  );
  const [selectedLocale, setSelectedLocale] = useState(
    locales?.[0]?.value || country.locale
  );

  function handleCtaClick(e) {
    e.preventDefault();
    setAvatarCreationVisible(true);
    track("opened_personalisation", {
      category: "Avatars 3.0",
      label: prismicProduct.main.productId,
    });
  }

  function handleAvatarCreationComplete(data) {
    let url = `/personalized-products/${props.productSlug}/preview`;
    url += qs.stringify({ ...data }, { addQueryPrefix: true });
    window.location = localiseUrlII(country, url);
  }

  return (
    <div className="ProductHeroII__button-wrap">
      {locales.length > 0 && (
        <SelectField
          id="ProductHeroII__locale-select"
          type="select"
          name="locale-select"
          label={localeLabel}
          options={locales}
          onChange={(e) => setSelectedLocale(e.target.value)}
        />
      )}

      <Button className="ProductHeroII__button" onClick={handleCtaClick}>
        {props.productCtaButtonText}
      </Button>

      <AvatarCreationModal
        className="ProductHeroII__avatar-modal"
        isOpen={avatarCreationVisible}
        schemaEndpoint={topology.preview.schema}
        payloadBaseParams={{
          locale: selectedLocale,
          product_slug: prismicProduct.main.productId,
        }}
        sku={prismicProduct.main.productId}
        onHandleClose={() => setAvatarCreationVisible(false)}
        globalUiLabels={prismicGlobalContentModel.avatars}
        onHandleAllComplete={handleAvatarCreationComplete}
        avatarUiLabels={productAvatarCreation}
        onHandleCharacterTracking={(data, status) =>
          track(
            `${data.data.charType}_${data.data.charIndex + 1}_of_${
              data.data.charsToMake
            }_${status}`,
            {
              category: "Avatars 3.0",
              label: prismicProduct.main.productId,
            }
          )
        }
        onHandleIndexTracking={(data) =>
          track(
            `${data.data.charType}_index_selection_${data.data.charsToMake}`,
            {
              category: "Avatars 3.0",
              label: prismicProduct.main.productId,
            }
          )
        }
      />
    </div>
  );
};

ProductHeroIIButtonAvatars.propTypes = {
  productSlug: PropTypes.string,
  productCtaButtonText: PropTypes.string,
  avatarCreation: PropTypes.object,
  productAvatarCreation: PropTypes.object,
};

export default ProductHeroIIButtonAvatars;
